// extracted by mini-css-extract-plugin
export var deliberationsContainer = "deliberations-module--deliberations-container--63b91";
export var deliberationsDocumentList = "deliberations-module--deliberations-document-list--61e2e";
export var deliberationsLoadingSpinner = "deliberations-module--deliberations-loading-spinner--02ac2";
export var deliberationsLoadingWrapper = "deliberations-module--deliberations-loading-wrapper--544ac";
export var deliberationsMonthList = "deliberations-module--deliberations-month-list--7e713";
export var deliberationsYearWrapper = "deliberations-module--deliberations-year-wrapper--50f10";
export var tabHidden = "deliberations-module--tab-hidden--1e9f1";